/**
 * Copyright (c) Stanislav Shishankin
 *
 * This source code is licensed under the MIT license.
 */

let {Event, EventStack} = require('../Event');
let {LinkToView, LinkToElement} = require('./Link');

class ViewComponent extends Event{
    __addEvents(){
        if (this.__zzEvStatus === 0){
            //add events
            for (let link of this.__zzLinks){
                link.addEvents(this);
            }
            
            this.__zzEvStatus = 2;
        }
    }
    
    appendDOM( toDOM, beforeElement ){
        if (this.__zzEvStatus === 1){
            this.once('DOM:after-remove', this.appendDOM.bind(this, toDOM, beforeElement));
        }else{
            beforeElement || (beforeElement = null);

            if (beforeElement instanceof ViewComponent){
                beforeElement = beforeElement.__zzDOMChilds[0] || null;
            }

            //append childs
            for (let node of this.__zzDOMChilds) {
                toDOM.insertBefore(node, beforeElement);
            }

            //init events
            this.__addEvents();

            this.emit('DOM:after-append', this);
        }
    }

    async __clearEvents(){
        if (this.__zzEvStatus === 2){
            this.__zzEvStatus = 1;

            for (let link of this.__zzLinks){
                await link.clearEvents(this);
            }

            this.__zzEvStack.off();

            this.__zzEvStatus = 0;
        }
    }

    async removeDOM(){
        if (this.__zzEvStatus === 2){
            await this.__clearEvents();

            for (let node of this.__zzDOMChilds){
                if (node.parentNode){
                    node.parentNode.removeChild( node );
                }
            }

            this.emit('DOM:after-remove', this);
        }
    }

    __initDOM(){
        if ('content' in this.__Template){
            let list = this.__Template.content.cloneNode(true);
            this.__zzDOMChilds = Array.prototype.slice.call(list.childNodes);
        }else{
            let list = this.__Template.cloneNode(true);
            this.__zzDOMChilds = Array.prototype.slice.call(list.childNodes);
        }
    }

    ev(){
        return this.__zzEvStack.add.apply(this.__zzEvStack, arguments);
    }

    stackEvent(){
        return this.__zzEvStack.add.apply(this.__zzEvStack, arguments);
    }

    findAll(selector){
        if (selector instanceof Element){
            return [selector];
        }

        let result = [];

        for (let el of this.__zzDOMChilds){
            if (el instanceof Element){
                result = result
                    .concat(Array.prototype.slice.call(el.querySelectorAll(selector)))
                    .concat(el.matches(selector)?[el]:[]);
            }
        }
        
        if (result.length === 0){
            console.error('Template can not find:', selector);
        }
        
        return result;

        //return this.__zzDOMChilds.querySelectorAll(selector);
    }

    find(selector){
        for (let el of this.__zzDOMChilds){
            if (el instanceof Element){
                let result = el.matches(selector);
                if (result){
                    return el;
                }

                result = el.querySelector(selector);
                if (result){
                    return result;
                }
            }
        }
        
        console.error('Template can not find:', selector);
        
        return null;

        //return this.__zzDOMChilds.querySelectorAll(selector);
    }

/*    linkElements(selector, link){
        if (link instanceof LinkToElement){
            this.__zzLinks.push(link);

            link.linkElements(this, selector);
        }
    
        return this;
    }*/

    link(link){
        if (link instanceof LinkToView){
            this.__zzLinks.push(link);

            link.linkView(this);
        }

        return this;
    }

    constructor(T){
        super();
        
        this.__Template = T;
        this.__initDOM();

        this.__zzLinks = [];
        this.__zzEvStack = new EventStack;

        /* 0 - no events, 1 - still removing events, 2 - all events set */
        this.__zzEvStatus = 0;
    }
}

/* shortcut */
class Template{
    find(selector){
        return this.DOM.querySelector(selector);
    }

    createView(selector){
        return new ViewComponent( this.find(selector) );
    }

    constructor(body){
        this.DOM = body;
    }
}

function Loader(html){
    var tmp = document.implementation.createHTMLDocument();
    tmp.body.innerHTML = html;

    return new Template(tmp.body);
}

module.exports = {ViewComponent, Loader};